import React, { useEffect, useState,useRef } from "react";
import GenMaterialForm from "./GenMaterialForm";
import MaterialRunner from "./MaterialRunner";
import MaterialGenBox from "./MaterialGenBox";
import Error from "../../erros/Error";
import ActivateModel from "../../components/modals/ActivateaccountModel";
import { GenMaterialUrl, MaterialwebsocketUrl,CustomMaterialUrl } from "../../libs/env";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "reactstrap";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { useHistory } from "react-router-dom";

const MaterialGenerator = ({
  isLoaded,
  data,
  GenerateMaterial,
  IsGenerating,
  setIsGenerating,
  CreateMaterial,
  setShowSocketData,
  ShowSocketData,
  UpdateMaterial,
}) => {
  const history = useHistory();
  const [UserActiveModal, setUserActiveModal] = useState(false);
  const UserActiveToggle = () => setUserActiveModal(!UserActiveModal);
  const [EndGptResponse, setEndGptResponse] = useState(false);
  const [IsMaterialCreate, setIsMaterialCreate] = useState(true);
  const [IsStopGenerating, setIsStopGenerating] = useState(false);
  const [IsRegenerating, setIsRegenerating] = useState(false);
  const [formData, setFormData] = useState({
    age_group: "",
    level: "",
    objective: "",
    detail: "",
    material_id: "",
    credits: "",
  });
  const [MaterialData, setMaterialData] = useState({
    title: "",
    output_prompt_content: "",
    material_level: "",
    age_group: "",
    material_id: "",
    gpt_response:"",
    material_icon: "",
    material_type: "",
    meta_data: {}
  });

  if(IsRegenerating)
  {
    setMaterialData((MaterialData) => ({
      ...MaterialData,
      title: "",
      output_prompt_content: "",
      material_level: "",
      age_group: "",
    }));
    setIsRegenerating(false)
  }
  const ws = useRef(null);
  useEffect(() => {
    function startWebsocket(ws,user_id,IsStopGenerating) {
      if(!ws.current)
      {
        ws.current = new W3CWebSocket(`${MaterialwebsocketUrl}${user_id}`);
      }
      // Handle incoming messages
      ws.current.onopen = () => {
        console.log("WebSocket Client Connected");
      };
      ws.current.onmessage = (event) => {
        if(IsStopGenerating)
        {
          ws.current.send(
            JSON.stringify({
              action: "stop",
            })
          );
        }
        if (ShowSocketData) {
          const socket_data = JSON.parse(event.data);
          if (socket_data?.chunk_response) {
            console.log("gpt_response", socket_data?.chunk_response);
          }
          if (socket_data?.type === "error") {
            console.log("chatgpt_error", socket_data?.message);
          }
          if (socket_data?.title) {
            setMaterialData((MaterialData) => ({
              ...MaterialData,
              title: socket_data?.title ? socket_data?.title : "",
              output_prompt_content: socket_data?.m_content ? socket_data?.m_content : "",
              material_level: socket_data?.level ? socket_data?.level : "",
              age_group: socket_data?.age_group ? socket_data?.age_group : "",
              gpt_response: socket_data?.output_prompt,
              meta_data: socket_data?.metadata ? socket_data?.metadata : {},
            }));
          }

          if (socket_data?.response_end === "response ended") {
            setEndGptResponse(true);
          }
        }
      };

      // Handle errors
      ws.current.onerror = (event) => {
        console.error("WebSocket error:", event);
      };
      ws.current.onclose = () => {
        console.log("WebSocket Connection Closed. Trying to reconnect...");
        // Attempt to reconnect every 5 seconds
        setTimeout(function () {
          ws.current = null ;
          startWebsocket(ws,user_id,IsStopGenerating);
        }, 2000);
      };
      // Clean up on unmount
      return () => {
        ws.current.close();
      };
    }
    if (data?.user_id) {
      startWebsocket(ws,data?.user_id,IsStopGenerating);
    }
  }, [data, ShowSocketData,IsStopGenerating]);

  useEffect(() => {
    if (MaterialData?.title && !EndGptResponse) {
      window.addEventListener("beforeunload", alertUser);
      return () => {
        window.removeEventListener("beforeunload", alertUser);
      };
    }
  });
  const alertUser = (e) => {
    if (MaterialData?.title && !EndGptResponse) {
      e.preventDefault();
      e.returnValue = "";
    }
  };

  if (IsMaterialCreate && IsGenerating && EndGptResponse && MaterialData?.output_prompt_content) 
  {
    setIsMaterialCreate(false);
    CreateMaterial(MaterialData);
  }
  const clearformData = (edit_temp) => {
    if(edit_temp)
    {
      history.push(`/material/generate/${data?.id}`);
    }
  };
  const generate_button = () => {
    let form_submit = document.getElementById("SubmitForm");
    form_submit.click();
  };
  return (
    <>
      <Row
        className="g-0 custom_scroll"
      >
        <Col sm={12} 
          className={"f-col-lg-4 no-print border-right-1"}
        >
          <div class="col-12 p-4 stpy-3 border-bottom">
            <div class={`d-flex px-3`}>
                <nav
                  Style='--bs-breadcrumb-divider: url(&#34;&#34;);'
                  aria-label="breadcrumb"
                >
                  <ol class="breadcrumb mb-0 align-items-center flex-nowrap">
                    <li class="breadcrumb-item">
                      <a
                        id="breadcrumb_back"
                        href="/material/all"
                        class="text-ldark text-decoration-none pe-2"
                      >
                        <b>Home</b>
                      </a>
                    </li>
                    {data && data?.title ?(
                      <>
                      <svg width='35' height='20' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M6 12L10 8L6 4' stroke='#D0D5DD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/>
                      </svg>
                      <li
                        class="exercise-text breadcrumb-item rounded-5 py-1 px-2 fw-600"
                        style={{backgroundColor: "#EDF2FF", color: "#2E58D4"}}
                        aria-current="page"
                      >
                        <span>{data.title}</span>
                      </li>
                      </>
                    ): window.location.pathname.includes(CustomMaterialUrl)&& (
                      <>
                      <svg width='35' height='20' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M6 12L10 8L6 4' stroke='#D0D5DD' stroke-width='1.33333' stroke-linecap='round' stroke-linejoin='round'/>
                      </svg>
                      <li
                        class="exercise-text breadcrumb-item rounded-5 py-1 px-2 fw-600 ms-2"
                        style={{backgroundColor: "#EDF2FF", color: "#2E58D4"}}
                        aria-current="page"
                      >
                        <span>Create activity</span>
                      </li>
                      </>
                    )}
                  </ol>
                </nav>
            </div>
          </div>
          <GenMaterialForm
            GenerateMaterial={GenerateMaterial}
            data={data}
            setMaterialData={setMaterialData}
            IsGenerating={IsGenerating}
            UserActiveToggle={UserActiveToggle}
            setShowSocketData={setShowSocketData}
            formData={formData}
            setFormData={setFormData}
            clearformData={clearformData}
            setIsStopGenerating={setIsStopGenerating}
            IsStopGenerating={IsStopGenerating}
            setIsGenerating={setIsGenerating}
            IsRegenerating={IsRegenerating}
            setIsRegenerating={setIsRegenerating}
            generate_button={generate_button}
          />
        </Col>
        <Col sm={12} className="f-col-lg-8 bg-lblue no-print pb-3">
          {window.location.pathname.includes(GenMaterialUrl) ? (
            <>
              {IsGenerating || IsStopGenerating || MaterialData?.output_prompt_content ? (
                <MaterialGenBox
                  data={MaterialData}
                />
              ) : (
                <>
                  {window.location.pathname.includes(CustomMaterialUrl) ? (
                    <Row className="g-0 justify-content-center mt-5 pt-5">
                      <Col className="col-8 mt-5">
                        <div class="col-12 p-0 align-items-center rounded-5 border mt-2 bg-white px-5 py-4">
                          <div className="col-12 pb-3 bg-white rounded-header fs-5">
                            <b>Your generated material will be shown here</b>
                          </div>
                          <p className="border-bottom"></p>
                          <div className="col-12 pt-3">
                              <div className="lh-base pb-1"><span className="pe-1">1.</span> Set up your class activity </div>
                            <div className="lh-base pb-1"><span className="pe-1">2.</span> Clearly define the learning objective </div>
                            <div className="lh-base pb-1"><span className="pe-1">3.</span> Click “generate” to create your materials </div>
                            <div className="lh-base fst-italic">Need help? <a href="#">Watch our how to video.</a></div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ): data.detail ? (
                      <Error data={data} isLoaded={isLoaded} />
                    ) : (
                      <MaterialRunner
                        data={data}
                        isLoaded={isLoaded}
                        UpdateMaterial={UpdateMaterial}
                      />
                  )}
                </>
              )}
            </>
          ) : data.detail ? (
              <Error data={data} isLoaded={isLoaded} />
            ) : (
              <MaterialRunner
                data={data}
                isLoaded={isLoaded}
                UpdateMaterial={UpdateMaterial}
              />
          )}
        </Col>
        <ActivateModel
          data={data}
          isOpen={UserActiveModal}
          toggle={UserActiveToggle}
        />
      </Row>
    </>
  );
};

export default MaterialGenerator;
